<template>
  <div class="cpgyl">
    <!-- <div class="diandi"></div> -->
    <div v-wechat-title="$route.meta.title"></div>
    <div class="dhtBox">
      <div class="cdBox">
      <div class="logo"></div>

        <div @click="shouye" class="cd">首页</div>
        <div @click="fuwu" class="cd">产品服务</div>
        <div @click="sxy" class="cd">商学院</div>
        <div @click="cpgyl" class="cd bxz">产品供应链</div>
        <div @click="hzal" class="cd">合作案例</div>
        <div @click="ydd( hsk )" class="cd yddapp">
          移动端
          <div class="yddxiazai" v-if="hsk == 2">
            <div class="hezi">
              <!-- <div class="img img1"></div> -->
              <!-- <div class="text">米商云</div> -->
            </div>
            <div class="hezi">
              <div class="img img2">
                <img src="../../assets/images/9774f492e19d7134dca0552612911f5.jpg" alt="">
              </div>
              <div class="text">米小礼</div>
            </div>
            <div class="hezi">
              <!-- <div class="img img3"></div> -->
              <!-- <div class="text">商e通</div> -->
            </div>
          </div>
        </div>
        <!-- <div @click="mk" class="cd">米珈</div> -->
        <div @click="gywm" class="cd">关于我们</div>

      </div>
    </div>
    <div class="lbBox">
      <div class="lbBox1200">
        <div class="lbBox1200text lbBox1200text1">1折爆品 让你的成本骤降 利润暴升！</div>
        <div class="lbBox1200text lbBox1200text2">覆盖多行业全产品供应链，1折爆品供应，聚焦打造营销礼品的成本优势，助力商家降本提效！</div>
        <div class="lbBox1200text lbBox1200text2">将从用户角度出发，从品牌策略、设计方案、品质把关等唯独综合测评，选品更加多元化，</div>
        <div class="lbBox1200text lbBox1200text2">为商家业绩提升严格把控供应链关口，助力企业智能营销深度赋能！</div>
        <div class="lbBox1200imgbox">
          <div class="lbBox1200imgboxs lbBox1200imgboxs1"></div>
          <div class="lbBox1200imgboxs lbBox1200imgboxs2"></div>
          <div class="lbBox1200imgboxs lbBox1200imgboxs3"></div>
        </div>
      </div>
    </div>

    <div class="ddsarboxbox">
      <div class="ddsarbox">
        <div class="ddsar">
          <div class="ddsarimg ddsarimg1"></div>
          <div class="ddsartext ddsartext1">5000+SKU</div>
          <div class="ddsartext ddsartext2">全球精选  好卖好用</div>
        </div>
        <div class="ddsar">
          <div class="ddsarimg ddsarimg2"></div>
          <div class="ddsartext ddsartext1">15大品类</div>
          <div class="ddsartext ddsartext2">全行业覆盖  适用不同需求</div>
        </div>
        <div class="ddsar">
          <div class="ddsarimg ddsarimg3"></div>
          <div class="ddsartext ddsartext1">正品低价</div>
          <div class="ddsartext ddsartext2">各大品牌战略合作保证低价</div>
        </div>
        <div class="ddsar">
          <div class="ddsarimg ddsarimg4"></div>
          <div class="ddsartext ddsartext1">质量三包</div>
          <div class="ddsartext ddsartext2">国家三包规定严格售后保障</div>
        </div>
      </div>
    </div>



    <div class="rarterboxbox">
      <div class="rarterbox">
        <div class="btbox">
          <div class="bttext1">PARTNER</div>
          <div class="bttext2">/ 合 / 作 / 伙 / 伴 /</div>
        </div>
      </div>
      <div class="lbttbox">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/7.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/8.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/9.png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/10.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/111.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/222.png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/333.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/444.png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/555.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (1).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (2).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (3).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (4).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (5).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (6).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (7).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (8).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (9).png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (10).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (11).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (12).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (13).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (14).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (15).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (16).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (17).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (18).png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (19).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (20).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (21).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (22).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (23).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (24).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (25).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (26).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (27).png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
          <van-swipe-item>
            <div style="display: flex; justify-content: center">
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (28).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (29).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (30).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (31).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (23).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (32).png" alt="" />
                  </div>
                </div>

                <div class="shugang"></div>
              </div>
              <div class="hezidebox">
                <div class="shangpinsbox">
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (33).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <img src="../../assets/images/hzppt/g1 (34).png" alt="" />
                  </div>
                  <div class="shangpins">
                    <!-- <img src="../../assets/images/hzppt/g1 (27).png" alt="" /> -->
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="tijiaoboxbox">
      <div class="tijiaobox">
        <div class="biaoti">营销落地 顺势而为</div>
        <div class="biaogebox">
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="姓名"
              id="txt"
              value=""
              ref="name1"
              v-on:keyup="inputRef1"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="手机"
              id="txt"
              value=""
              ref="name2"
              v-on:keyup="inputRef2"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="公司名称"
              id="txt"
              value=""
              ref="name3"
              v-on:keyup="inputRef3"
            />
          </div>
          <div class="biaoge">
            <input
              class="index"
              type="text"
              name=""
              placeholder="省份"
              id="txt"
              value=""
              ref="name4"
              v-on:keyup="inputRef4"
            />
          </div>
        </div>
        <div class="tijiaobtn" @click="ziliao()">立即申请</div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "@/service/common.service.js";
export default {
  data() {
    //

    return {
      name1: "name1",
      name2: "name2",
      name3: "name3",
      name4: "name4",
      hsk:1,

    };
  },
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    inputRef1: function () {
      console.log(this.$refs.name1.value);
      this.name1 = this.$refs.name1.value;
    },
    inputRef2: function () {
      console.log(this.$refs.name2.value);
      this.name2 = this.$refs.name2.value;
    },
    inputRef3: function () {
      console.log(this.$refs.name3.value);
      this.name3 = this.$refs.name3.value;
    },
    inputRef4: function () {
      console.log(this.$refs.name4.value);
      this.name4 = this.$refs.name4.value;
    },
    ziliao() {
      console.log(this.name1);
      console.log(this.name2);
      console.log(this.name3);
      console.log(this.name4);
      if (
        this.name1 == "" ||
        this.name1 == "name1" ||
        this.name1 == undefined
      ) {
        this.$toast("请输入您的姓名");
      } else if (
        this.name2 == "" ||
        this.name2 == "name2" ||
        this.name2 == undefined
      ) {
        this.$toast("请输入您的手机号");
      } else if (
        this.name3 == "" ||
        this.name3 == "name3" ||
        this.name3 == undefined
      ) {
        this.$toast("请输入您的公司名称");
      } else if (
        this.name4 == "" ||
        this.name4 == "name4" ||
        this.name4 == undefined
      ) {
        this.$toast("请输入您的省份");
      } else {
        this.tech_www();
      }
    },
    ydd(e){
       if(e == 1){
        this.hsk = 2
      }else{
        this.hsk = 1

      }
      console.log(this.hsk)
      
    },
shouye() {
      this.$router.push({
        path: "/",
      });
    },
    fuwu() {
      this.$router.push({
        path: "/cpfu",
      });
    },
    sxy() {
      this.$router.push({
        path: "/sxy",
      });
    },
    cpgyl() {
      this.$router.push({
        path: "/cpgyl",
      });
    },
    hzal() {
      this.$router.push({
        path: "/hzal",
      });
    },
    mk() {
      this.$router.push({
        path: "/mk",
      });
    },
    gywm() {
      this.$router.push({
        path: "/gywm",
      });
    },
    // 数据提交
    tech_www() {
      let form_data = new FormData();
      // 姓名
      form_data.append("name", this.name1);
      // 电话
      form_data.append("jobs", this.name2);
      // 需求
      form_data.append("company", this.name3);
      // 省份
      form_data.append("province", this.name4);
      // // 身份证反面照片
      // form_data.append("idcardReversePhoto", this.idcardReversePhoto);

      API.tech_www(form_data).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          // this.typeofwork = res.data.dicList;
          // this.$router.push({
          //   path: "/success"
          // });
          this.$toast(res.data.msg);
        } else {
          // 弹出返回文字
          this.$toast(res.data.msg);
        }
      });
    },
    // 提交数据接口
  },
};
</script>

<style lang="scss">
.cpgyl {
  font-size: 0.16rem;
  background: #fff;
  .dhtBox{
      background: none;
        .bxz{
      border-bottom: 2px solid #fff;
    }
  }

  .lbBox {
    width: 100%;
    // height: 8.34rem;
    background: url("../../../src/assets/images/1231232.png");
    background-size: 100% 100%;
    // position: absolute;
    // top: 0;
    z-index: -1;
    margin-top: -0.98rem;
    padding-top: 2.16rem;

    box-sizing: border-box;
    .lbBox1200{
      width: 1200px;
      margin: 0 auto;
      .lbBox1200text{
        text-align: center;
      }
      .lbBox1200text1{
        font-size: 0.60rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        margin-bottom: 0.5rem;
      }
      .lbBox1200text2{
        font-size: 0.18rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFEFE;
        line-height: 0.38rem;
      }
      .lbBox1200text:nth-child(4){
        margin-bottom: 1rem;
      }
      .lbBox1200imgbox{
        display: flex;
        flex-wrap: wrap;
        .lbBox1200imgboxs{
          width: 4rem;
          height: 2.56rem;
          background-size: 100% 100%;
              margin-bottom: 0.4rem;
        }
        .lbBox1200imgboxs1{
          background: url('../../assets/images/111111.png') no-repeat center;
        }
        .lbBox1200imgboxs2{
          background: url('../../assets/images/222222.png') no-repeat center;
        }
        .lbBox1200imgboxs3{
          background: url('../../assets/images/333333.png') no-repeat center;
        }
      }
    }
  }
  .ddsarboxbox{
    width: 100%;
    background: #fff;
    .ddsarbox{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;
      padding-top: 0.9rem;
      padding-bottom: 1.16rem;
      .ddsar{
        .ddsarimg{
          width: 1.4rem;
          height: 1.4rem;
          margin-bottom: 0.2rem;
        }
        .ddsarimg1{
          background: url('../../assets/images/19.png');
          margin: 0 auto;
          margin-bottom: 0.2rem;

        }
        .ddsarimg2{
          background: url('../../assets/images/20.png');
          margin: 0 auto;
          margin-bottom: 0.2rem;


        }
        .ddsarimg3{
          background: url('../../assets/images/21.png');
          margin: 0 auto;
          margin-bottom: 0.2rem;

        }
        .ddsarimg4{
          background: url('../../assets/images/-48612.png');
          margin: 0 auto;
          margin-bottom: 0.2rem;

        }
        .ddsartext{
          text-align: center;
        }
        .ddsartext1{
          margin-bottom: 0.1rem;
          font-size: 0.22rem;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #101127;
        }
        .ddsartext2{
          font-size: 0.17rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #2A7CEF;
          line-height: 0.29rem;
        }
      }
    }
  }





  .rarterboxbox {
    width: 100%;
    background: #fbfbfb;
    padding-bottom: 1.5rem;
    .rarterbox {
      width: 1200px;
      margin: 0 auto;
      padding-top: 0.73rem;

      .btbox {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        margin-bottom: 1rem;
        .bttext1 {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.35rem;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #313131;
        }
        .bttext2 {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 0.16rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #6c6c6c;
        }
      }
      .hezidebox {
        display: flex;
        .shangpinsbox {
          .shangpins {
            width: 4rem;
            height: 1.6rem;
            border-bottom: 1px solid #e1e0e0;
            padding-right: 0.57rem;
            padding-bottom: 0.15rem;
            padding-top: 0.15rem;
            padding-left: 0.5rem;
            .img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .shangpins:nth-child(1) {
            margin-left: 0rem;
          }
          .shangpins:nth-child(3) {
            margin-right: 0rem;
            border-bottom: none;
          }
        }

        .shugang {
          width: 0.01rem;
          height: 4.8rem;
          background: #e1e0e0;
        }
      }
    }
    .lbttbox {
      width: 12rem;
      margin: 0 auto;
      .hezidebox {
        display: flex;
        .shangpinsbox {
          .shangpins {
            width: 4rem;
            height: 1.6rem;
            border-bottom: 1px solid #e1e0e0;
            padding-right: 0.57rem;
            padding-bottom: 0.15rem;
            padding-top: 0.15rem;
            padding-left: 0.5rem;
            .img {
              display: block;
              width: 100%;
              height: 100%;
            }
          }
          .shangpins:nth-child(1) {
            margin-left: 0rem;
          }
          .shangpins:nth-child(3) {
            margin-right: 0rem;
            border-bottom: none;
          }
        }

        .shugang {
          width: 0.01rem;
          height: 4.8rem;
          background: #e1e0e0;
        }
      }
    }
  }
  .tijiaoboxbox {
    width: 100%;
    background: url("../../assets/images/jiao.png") no-repeat center;
    background-size: 100% 100%;
    .tijiaobox {
      width: 1200px;
      height: 4.64rem;
      margin: 0 auto;
      .biaoti {
        font-size: 0.42rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
        padding-top: 0.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 0.9rem;
      }
      .biaogebox {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1rem;
        .biaoge {
          width: 2.76rem;
          height: 0.42rem;
          background: #ffffff;
          border-radius: 0.1rem;
          margin-left: 0.11rem;
          margin-right: 0.11rem;
          .index {
            width: 100%;
            height: 100%;
            padding-left: 0.2rem;
            box-sizing: border-box;
            border-radius: 0.1rem;
            border: none;
          }
        }
      }
      .tijiaobtn {
        width: 1.62rem;
        height: 0.5rem;
        border: 0.02rem solid #ffffff;
        border-radius: 0.1rem;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.2rem;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cpgyl/index.vue